import React, { useEffect, useState } from 'react'
import './payment.scss'
import { PaymentPresenter } from './payment-presenter'
import { useNavigate, useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../store'
import { projectServices, investServices } from '../../services'
import { getFileKeyFromSignedUrl } from '../../lib/utils/helpers'
import { showBanner } from '../../global-state/banner-slice'
import { Investment, OpportunityDetails } from '../../lib/types'

const PaymentContainer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const params = useParams()
  const { projectSlug, projectId, paymentPage } = params
  const { authToken } = useSelector((state: RootState) => state.investor)
  const [project, setProject] = useState<OpportunityDetails>()
  const [investmentData, setInvestmentData] = useState<Investment>()
  const [showContactUsModal, setContactUsModal] = useState(false)

  useEffect(() => {
    const fetchProjectById = async () => {
      const data = await projectServices.getOpportunityById(projectId as string, {
        Authorization: authToken ? authToken : '',
      })
      if (data && data.data && data.status === 200) {
        setProject(data.data)
      }
    }
    const getUserInvestmentLatest = async () => {
      const response = await investServices.getInvestmentLatest_v1(
        { opportunityId: projectId ? parseInt(projectId) : 0 },
        {
          Authorization: authToken ? authToken : '',
        },
      )
      if (response && response.data && response.status === 200) {
        setInvestmentData(response.data)
      }
    }

    if (projectId) {
      fetchProjectById()
      getUserInvestmentLatest()
    }
  }, [projectId])

  const handleViewSummary = () => {
    navigate(`/payment/${projectSlug}/${projectId}/payment-summary`)
  }

  const handlePrintPaymentSummary = () => {
    window.print()
  }
  const handleShowContactUsModal = () => setContactUsModal(!showContactUsModal)

  const handleFilePreview = async (fileKey: string) => {
    const signedUrl = getFileKeyFromSignedUrl(fileKey)
    const data = await projectServices.previewFile(signedUrl, {
      Authorization: authToken ? authToken : '',
    })
    if (data && data.data && data.status === 200) return data.data.url
    else {
      dispatch(
        showBanner({
          text: (data.data && data.data.message) || 'Something went wrong preview document',
          variant: 'error-banner',
        }),
      )
      return ''
    }
  }

  return (
    <>
      {project && (
        <PaymentPresenter
          opportunity={project}
          paymentPage={(paymentPage && paymentPage) || ''}
          handlePrintPaymentSummary={handlePrintPaymentSummary}
          handleViewSummary={handleViewSummary}
          investmentData={investmentData!}
          showContactUsModal={showContactUsModal}
          handleShowContactUsModal={handleShowContactUsModal}
          handleFilePreview={handleFilePreview}
        />
      )}
    </>
  )
}

export { PaymentContainer }
